import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "@/components/SEO";
import { inputClass } from "@/components/Shared";
import { adminLogin } from "@/lib/api";

const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const data = await adminLogin(email, password);
      localStorage.setItem("lumiere_admin", JSON.stringify(data));
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="admin-login-page">
      <SEO title="Practice Login | Lumière Aesthetics" description="Practice team login." />
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src="/images/lumiere-logo.png" alt="Lumière Aesthetics" className="h-8 w-auto mx-auto" />
          <p className="eyebrow mt-6">Practice dashboard</p>
        </div>
        <form onSubmit={onSubmit} className="bg-warm-white relative p-10 space-y-5" data-testid="admin-login-form">
          <div className="gold-frame inset-3 opacity-70" aria-hidden="true" />
          <div className="relative space-y-5">
            <div>
              <label htmlFor="admin-email" className="eyebrow block mb-2">Email</label>
              <input id="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input" className={inputClass} autoComplete="username" />
            </div>
            <div>
              <label htmlFor="admin-password" className="eyebrow block mb-2">Password</label>
              <input id="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input" className={inputClass} autoComplete="current-password" />
            </div>
            {error && <p className="text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={busy} data-testid="admin-login-submit"
              className="btn-gold w-full px-8 py-4 text-sm font-medium tracking-[0.06em] disabled:opacity-60">
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
